<template>
<div class="navbar-menu__submenu navbar-dropdown" >
    <div class="container">
        <div class="standard-submenu is-variable" v-if="item.sub.length" :style="computedStyle">
            <div class="row" v-for="subitem, n in item.sub">
                <div class="columns is-4 standard-submenu__list">
                    <router-link class="standard-submenu__item" :to="subitem.url" :key="'secondary-' + n">
                        {{subitem.label}}
                        <button v-if="subitem.sub.length" @click.prevent="subitem.toggled = !subitem.toggled" :class="['standard-submenu__toggle-button', {'is-toggled': subitem.toggled}]"><span class="icon"><i class="fas fa-angle-right"></i></span></button>
                    </router-link>
                    <ul :class="['standard-submenu__submenu', {'is-toggled': subitem.toggled}]">
                        <li v-for="tertiary, k in subitem.sub">
                            <router-link class="standard-submenu__submenu__item" :to="tertiary.url">{{tertiary.label}}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ViewBlockItemMixin from '@/components/mixins/ViewBlockItemMixin';
export default {
    name    :   'StandardSubmenu',
    props   :   ['item', 'submenu_x'],
    mixins  :   [ ViewBlockItemMixin ],
    computed: {
        computedStyle() {
            return {
                left: this.submenu_x,
            };
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/elements/StandardSubmenu.vue